import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { ROUTES } from 'config/constants';
import { getPostLoginRouteForUser } from 'utils/platformAdmin';

const UnauthRoute = ({
  component: Component,
  isAuthenticated,
  authState = {},
  ...rest
}) => {
  window.initializedAppcues.then((appcues) => {
    try {
      appcues.anonymous();
    } catch (error) {
      console.error('APPCUES INITIALIZATION FAILED');
      console.error(error);
    }
  });

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Redirect to={getPostLoginRouteForUser(authState.authInfo?.groups)} />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

UnauthRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ authState }) => ({
  isAuthenticated: !!authState.isAuth,
  authState,
});

export default connect(mapStateToProps)(UnauthRoute);
